import api from "./api";

export async function getGoals (
    status = '',
    currentPage = 1,
    q='',
    onlyTrashed = false,
) {
    return api.get(`/goals?q=${q}&status=${status}&paginate=true&page=${currentPage}&onlyTrashed=${onlyTrashed}`)
}

export async function getGoal(id) {
    return api.get(`/goals/${id}&limit=1`)
}

export async function getGoalId(id) {
    return api.get(`/goals/${id}&limit=1`)
        .then(response => response.data.data)
        .catch(error => console.log(error));
}

export function setGoal (id, data) {
    return api.put(`/goals/${id}`, data);
}

export function dellGoal (id, forceDelete = false) {
    return api.delete(`/goals/${id}?forceDelete=${forceDelete}`)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function restoreGoal (id) {
    return api.post(`/goals/${id}/restore`)
        .then(response => response.data)
        .catch(error => console.log(error));
}


